import {
  getData,
  postData,
} from './Services'

export const getInventariosDetPanel = async (searchAjuCab,searchDepoid, searchArt, page, perPage) => {
  let queryParams = [];
  if (searchAjuCab) {
    queryParams.push(`ajud_aju_id=${encodeURIComponent(searchAjuCab)}`);
  }
  if (searchDepoid) {
    queryParams.push(`ajud_depo_id=${encodeURIComponent(searchDepoid)}`);
  }
  if (searchArt) {
    queryParams.push(`ajud_art_id=${encodeURIComponent(searchArt)}`);
  }  
  if (page) {
    queryParams.push(`page=${encodeURIComponent(page)}`);
  }
  if (perPage) {
    queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
  }
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await getData("/artAjustesDet/art_ajustes_detalles", queryString);
}


export const getInventarioDetById = async (id) => {
  const res = await getData(`/artAjustesDet/${id}`)
  return res
}

export const postInventarioDet = async (body) => {
  const res = await postData('/artAjustesDet', body)
  return res
}